'use es6';

export const ITEMS_PER_PAGE_SMALL = 5;
export const ITEMS_PER_PAGE_LARGE = 15;
const MAXIMUM_RECORDS = 10000;
export function sliceArrayToPage(page, arrayToPaginate, itemsPerPage) {
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = page * itemsPerPage;
  return arrayToPaginate.slice(startIndex, endIndex);
}
export function getPageCount(total, itemsPerPage = ITEMS_PER_PAGE_SMALL) {
  const totalPages = Math.ceil(total / itemsPerPage);
  const maxPagesSupported = Math.floor(MAXIMUM_RECORDS / itemsPerPage);
  return Math.min(totalPages, maxPagesSupported);
}
export function overrideLimitBasedOnReportHeight(report, height) {
  if (height === 1 || height === 2) {
    return report.setIn(['config', 'limit'], height === 1 ? ITEMS_PER_PAGE_SMALL : ITEMS_PER_PAGE_LARGE);
  }
  return report;
}

/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking
if (!!module && !!module.exports) {
  module.exports.default = module.exports;
}